<template>
    <div class="expander">
        <div class="expander__content" :class="contentCssClass">
            <slot/>
        </div>
        <slot name="expander" v-if="showExpander" :callback="onExpand">
            <div class="expander__toggle">
                <a class="button--cta" @click="onExpand">
                    {{$t('expander.label_expand')}}
                </a>
            </div>
        </slot>
        <slot name="collapser" v-if="showCollapser" :callback="onCollapse">
            <div class="expander__toggle">
                <a class="button--cta" @click="onCollapse">
                    {{$t('expander.label_collapse')}}
                </a>
            </div>
        </slot>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class Expander extends Vue {
        @Prop({type: Boolean, default: true})
        allowExpand;
        @Prop({type: Boolean, default: true})
        allowCollapse;
        @Prop({type: Boolean, default: false})
        forceExpanded;
        @Prop({type: Boolean, default: false})
        forceCollapsed;
        @Prop({type: Number, default: 300})
        collapsedHeight;
        @Prop({type: String, default: 'expander__content--expanded'})
        expandedCssClass;
        @Prop({type: String, default: 'expander__content--collapsed'})
        collapsedCssClass;
        expandedInternal = false;

        get expanded() {
            return (this.forceExpanded || this.expandedInternal) && !this.forceCollapsed;
        }

        set expanded(value) {
            if (!this.forced) {
                console.log('set', this.expandedInternal);
                this.expandedInternal = value;
                this.$emit(this.expandedInternal ? 'expand' : 'collapse');
            }
        }

        get contentCssClass() {
            return this.expanded ? this.expandedCssClass : this.collapsedCssClass;
        }

        get forced() {
            return this.forceExpanded || this.forceCollapsed;
        }

        get showExpander() {
            return !this.forced && this.allowExpand && !this.expanded;
        }

        get showCollapser() {
            return !this.forced && this.allowCollapse && this.expanded;
        }

        onExpand() {
            this.expanded = true;
        }

        onCollapse() {
            this.expanded = false;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Expander.vue